import React, { useState } from 'react';
import { TextField, Button, Typography } from '@mui/material';
import { registerTeacher } from '../api/authApi';
import { useNavigate } from 'react-router-dom';
import BackButton from '../components/BackButton';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      await registerTeacher(email, password);
      setMessage('ثبت‌نام موفق بود! حالا وارد شوید.');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setMessage('ثبت‌نام ناموفق بود. شاید ایمیل قبلاً ثبت شده.');
    }
  };

  return (
    <div  dir="rtl" style={{ padding: '2rem', maxWidth: '400px', margin: 'auto' }}>
       <header style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <BackButton toFallback="/dashboard" />
        </header>
      <Typography variant="h5" gutterBottom>ثبت‌نام معلم</Typography>
      <TextField
        label="ایمیل"
        fullWidth
        margin="normal"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        label="رمز عبور"
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {message && <Typography color="primary">{message}</Typography>}
      <Button variant="contained" fullWidth onClick={handleRegister}>ثبت‌نام</Button>
    </div>
  );
};

export default RegisterPage;
